import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import tradeApi from "./tradeApi";

export const getSpotOpenOrderList = createThunkFromApi(
  "trade/getSpotOpenOrderList",
  tradeApi.getSpotOpenOrderList
);

export const getMarginOpenOrderList = createThunkFromApi(
  "trade/getMarginOpenOrderList",
  tradeApi.getMarginOpenOrderList
);

export const getSpotTradeLast24HList = createThunkFromApi(
  "trade/getSpotTradeLast24HList",
  tradeApi.getSpotTradeLast24HList
);

export const getMarginTradeLast24HList = createThunkFromApi(
  "trade/getMarginTradeLast24HList",
  tradeApi.getMarginTradeLast24HList
);

export const cancelOrder = createThunkFromApi(
  "trade/cancelOrder",
  tradeApi.cancelOrder
);

export const getTradeInitial = createThunkFromApi(
  "trade/getTradeInitial",
  tradeApi.getTradeInitial
);

export const getTradeAmountMax = createThunkFromApi(
  "trade/getTradeAmountMax",
  tradeApi.getTradeAmountMax
);

export const getTradeForm = createThunkFromApi(
  "trade/getTradeForm",
  tradeApi.getTradeForm
);

export const getHistoryOrderForm = createThunkFromApi(
  "trade/getHistoryOrderForm",
  tradeApi.getHistoryOrderForm
);

export const getTradeList = createThunkFromApi(
  "trade/getTradeList",
  tradeApi.getTradeList
);

export const getHistoryOrderList = createThunkFromApi(
  "trade/getHistoryOrderList",
  tradeApi.getHistoryOrderList
);

const initialState = {
  loading: false,
  tradeHistory: null,
  tradeInitial: null,
  tradeAmountMax: null,
  tradeForm: null,
};

export const convertSlice = createSlice({
  name: "trade",
  initialState,

  extraReducers: {
    [getMarginTradeLast24HList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getTradeList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getHistoryOrderList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getSpotTradeLast24HList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getTradeForm.fulfilled]: (state, { payload }) => {
      state.tradeForm = payload.data;
    },

    [getHistoryOrderForm.fulfilled]: (state, { payload }) => {
      state.tradeForm = payload.data;
    },

    [getMarginOpenOrderList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getSpotOpenOrderList.fulfilled]: (state, { payload }) => {
      state.tradeHistory = payload.data;
    },

    [getTradeInitial.pending]: (state) => {
      state.loading = true;
    },

    [getTradeInitial.rejected]: (state) => {
      state.loading = true;
    },

    [getTradeInitial.fulfilled]: (state, { payload }) => {
      state.tradeInitial = payload.data;
      state.loading = false;
    },

    [getTradeAmountMax.fulfilled]: (state, { payload }) => {
      state.tradeAmountMax = payload.data;
    },
  },
});

export default convertSlice.reducer;
